import { CircularProgress } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import Alert from "$components/Alert";
import OrderForm from "$containers/Orders/forms/OrderForm";
import { ReceptionService } from "$services";
import { CacheInvalidationAction } from "$utils/cache";

export const OrderFormPopin = ({ order, isOrder, togglePopin }: any) => {
  const { data, isLoading, error } = useQuery({
    queryKey: [CacheInvalidationAction.GET_ORDER_BY_ID, order.id],
    queryFn: () => ReceptionService.getOrderById(order.id),
    staleTime: 1000 * 60,
  });

  return (
    <>
      {data && <OrderForm order={data} onReset={togglePopin} />}
      {isLoading && <CircularProgress size={64} />}
      {error && (
        <Alert severity="error">{`Une erreur est survenue lors de l'obtention de la ${
          isOrder ? "" : "sous-"
        }commande n°${order.reference}.`}</Alert>
      )}
    </>
  );
};
